import { ReactElement } from "react";
import toast, { ToastOptions } from "react-hot-toast";
import { Toast } from "react-hot-toast/src/core/types";
import SuccessIcon from "@/assets/svgs/icons/toast_success.svg";
import ErrorIcon from "@/assets/svgs/icons/toast_error.svg";
import WarningIcon from "@/assets/svgs/icons/toast_warning.svg";
import { CloseIcon } from "@/assets/svgs/icons";


type ToastType = "success" | "error" | "warning";

type ToastContent = {
    message: string | ReactElement,
    type?: ToastType
};

const defaultToastStyle = {
    backgroundColor: "#ffffff",
    boxShadow: "0 0 6px 0 #BDBDBD",
    padding: "6px 2px",
    borderRadius: "6px",
};

const defaultToastOptions: Partial<ToastOptions> = {
    duration: 4000
};

const commonMessage = (t: Toast, content: ToastContent) => {
    const { message, type } = content;

    let icon: string | undefined;
    if (type === "success") {
        icon = SuccessIcon;
    } else if (type === "error") {
        icon = ErrorIcon;
    } else if (type === "warning") {
        icon = WarningIcon;
    }

    return (
        <div data-toast-type={type}
             className="w-full flex items-center"
        >
            {icon && (
                <img src={icon} alt="toast"
                     className="mr-2 size-6"
                />
            )}

            <span className="text-black-500 text-[14px] leading-[1.5] font-[500] mr-4">
                {message}
            </span>

            <div className="min-w-4 cursor-pointer">
                <CloseIcon className="size-4"
                           onClick={() => toast.dismiss(t.id)}
                />
            </div>
        </div>
    );
};

export const successToast = (message: string | ReactElement, options?: ToastOptions) => {
    const { style: customStyle = {}, ...customOptions } = options ?? {};
    return toast(t => commonMessage(t, { message, type: "success" }), {
        style: {
            ...defaultToastStyle,
            ...customStyle
        },
        ...defaultToastOptions,
        ...customOptions,
    });
};

export const errorToast = (message: string | ReactElement, options?: ToastOptions) => {
    const { style: customStyle = {}, ...customOptions } = options ?? {};
    return toast(t => commonMessage(t, { message, type: "error" }), {
        style: {
            ...defaultToastStyle,
            ...customStyle
        },
        ...defaultToastOptions,
        ...customOptions,
    });
};

export const warningToast = (message: string | ReactElement, options?: ToastOptions) => {
    const { style: customStyle = {}, ...customOptions } = options ?? {};
    return toast(t => commonMessage(t, { message, type: "warning" }), {
        style: {
            ...defaultToastStyle,
            ...customStyle
        },
        ...defaultToastOptions,
        ...customOptions,
    });
};
